module.exports = __webpack_public_path__ + "img/bird04.236b071d.png";